import { render } from "./refresh-icon.vue?vue&type=template&id=96876a5c"
import script from "./refresh-icon.vue?vue&type=script&lang=js"
export * from "./refresh-icon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__